import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringAccountListModel } from '@apps-common/types/portal/my-monitoring'

export const QUERY_KEY_SEARCH_MY_MONITORING_ACCOUNTS = (search?: string, skip?: number, take?: number) =>
  ['searchMyMonitoringAccounts', search, skip, take].filter(Boolean)

export const searchMyMonitoringAccounts = async (skip: number, take: number, search?: string): Promise<IMyMonitoringAccountListModel[]> =>
  axios.get(`/MyMonitoringAccountManagement/SearchAccounts?search=${search || ''}&skip=${skip}&take=${take}`).then((res) => res.data?.data)

type QueryFnType = typeof searchMyMonitoringAccounts

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
  skip: number
  take: number
}

export const useSearchMyMonitoringAccounts = ({ config, search, skip, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_SEARCH_MY_MONITORING_ACCOUNTS(search, skip, take),
    queryFn: () => searchMyMonitoringAccounts(skip, take, search)
  })
